<template>

  <div class="cc-card-title cc-flex cc-flex-between">

    <div class="cc-button-icon" @click="selectPrevious">
      <ccIcon name='arrow_left'></ccIcon>
    </div>

    <span>{{ selectedMonth }}</span>

    <div class="cc-button-icon" @click="selectNext">
      <ccIcon name='arrow_right'></ccIcon>
    </div>

  </div>

</template>

<script>
import dayjs from "dayjs";
import ccIcon from "../../components/ccIcons";

export default {
    name: "CalendarModeSelector",

    props: {
        currentDate: {
        type: String,
        required: true
        },

        selectedDate: {
        type: Object,
        required: true
        }
    },

    components: {
        ccIcon
    },

    computed: {
        selectedMonth() {
            let locales = {
                nl: require("dayjs/locale/nl"),
                en: require("dayjs/locale/en")
            }

            if(this.$i18n.locale in locales){
                return dayjs(this.selectedDate).locale(locales[this.$i18n.locale]).format("MMMM YYYY")
            }


            return this.selectedDate.format("MMMM YYYY");
        }
    },

    methods: {
        selectPrevious() {
        let newSelectedDate = dayjs(this.selectedDate).subtract(1, "month");
        this.$emit("dateSelected", newSelectedDate);
        },

        selectCurrent() {
        let newSelectedDate = dayjs(this.currentDate);
        this.$emit("dateSelected", newSelectedDate);
        },

        selectNext() {
        let newSelectedDate = dayjs(this.selectedDate).add(1, "month");
        this.$emit("dateSelected", newSelectedDate);
        }
    },

    created(){
        // let locales = {
        //     nl: require("dayjs/locale/nl"),
        //     en: require("dayjs/locale/en")
        // }

        // dayjs.locale(locales[this.$i18n.locale])
    }

};
</script>
